/**
 * Phone inputs emit '' when cleared, but the column is nullable — store null
 * for blank so '' and null never mix in the database.
 */
export const normalizeBlankPhone = (value?: string | null): string | null =>
  value?.trim() ? value : null;
